import { JSON } from "./json";

(window as any).JSON = (window as any).JSON || JSON;
